// ─── CONFIGURACIÓN DE LA OFERTA ────────────────────────────────
// Reemplazá OFFER_END_DATE por la fecha/hora real de finalización
// (formato ISO con zona horaria, ej. Argentina = -03:00).
export const OFFER_END_DATE = '2026-10-07T23:59:00-03:00';

// 'evergreen' = temporizador por visitante (OFFER_DURATION_MINUTES desde su primera visita)
// 'fixed'     = cuenta regresiva hasta OFFER_END_DATE
export const OFFER_MODE: 'evergreen' | 'fixed' = 'evergreen';
export const OFFER_DURATION_MINUTES = 60;

// Reemplazá por el link real de tu checkout (Hotmart, Mercado Pago, etc.)
export const CHECKOUT_URL = 'https://kit-sexologia-practica.impultienda.ar/checkout';

export const PRICE = '$16.990';

// Precio real habitual (sin descuento). Debe ser el precio al que efectivamente se vende.
export const ORIGINAL_PRICE = '$39.980';
export const DISCOUNT_LABEL = '57% de descuento';

export const CTA_LABEL = 'Quiero acceder al Kit Sexualidad Práctica';

export const MOCKUP_URL =
  'https://cdn.magicpatterns.com/uploads/3gmLg78nMvK83WRJ5YNqXT/ChatGPT_Image_30_sept_2026,_20_34_00.png';


export const TABLET_IMAGE_URL =
  'https://cdn.magicpatterns.com/patterns/generated-images/da5b8194-3a81-4e1c-b0e1-223928f80985.jpg';
